import { z } from "zod";

// Environment schema for integration environments
export const IntegrationEnvironmentSchema = z.object({
  name: z.string(),
});

// Common base schema for integration fields
const IntegrationBaseSchema = z.object({
  id: z.coerce.string(),
  name: z.string(),
  integration_type: z.enum(["dbt_core", "dbt_cloud"]),
});

// Integration schema for individual integration items
export const IntegrationSchema = IntegrationBaseSchema.extend({
  environments: z.array(IntegrationEnvironmentSchema).optional(),
  is_deleted: z.boolean().optional(),
  connection_name: z.string().nullable().optional(),
});

// Integration list response schema
export const IntegrationListResponseSchema = z.array(IntegrationSchema);

// Sync history item schema
export const SyncHistorySchema = z.object({
  type: z.string(),
  time: z.string(),
  log_file: z.string().optional(),
});

// Integration details schema (for individual integration details)
export const IntegrationDetailsSchema = IntegrationBaseSchema.extend({
  environment_name: z.string(),
  sync_history: z.array(SyncHistorySchema),
  is_deleted: z.boolean().optional(),
});

// Post integration schemas
export const PostIntegrationRequestSchema = z.object({
  name: z.string(),
  integration_type: z.enum(["dbt_core", "dbt_cloud"]),
  environment: z.string(),
});

export const PostIntegrationResponseSchema = z.object({
  dbt_core_integration_id: z.number().optional(),
});

// Inferred types
export type IntegrationEnvironment = z.infer<typeof IntegrationEnvironmentSchema>;
export type Integration = z.infer<typeof IntegrationSchema>;
export type IntegrationListResponse = z.infer<typeof IntegrationListResponseSchema>;
export type SyncHistory = z.infer<typeof SyncHistorySchema>;
export type IntegrationDetails = z.infer<typeof IntegrationDetailsSchema>;
export type PostIntegrationRequest = z.infer<typeof PostIntegrationRequestSchema>;
export type PostIntegrationResponse = z.infer<typeof PostIntegrationResponseSchema>;
